import { render, staticRenderFns } from "./RelatedNewsItem.vue?vue&type=template&id=735703c8&scoped=true&"
import script from "./RelatedNewsItem.vue?vue&type=script&lang=ts&"
export * from "./RelatedNewsItem.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedNewsItem.vue?vue&type=style&index=0&id=735703c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735703c8",
  null
  
)

export default component.exports